// v3.18-1388 CRM-INT-005 — 404 shown when a non-CEO user tries to open
// /dashboard directly.  Mirrors a generic browser-style Not Found so the
// route reveals nothing about the Dashboard's existence.
import { Link } from 'react-router-dom';

const DashboardNotFound = () => (
  <div
    data-testid="dashboard-not-found"
    className="flex flex-col items-center justify-center py-24 px-6 text-center"
  >
    <div className="text-6xl font-bold text-slate-300 mb-4">404</div>
    <h1 className="text-2xl font-semibold text-slate-700 mb-2">
      Page not found
    </h1>
    <p className="text-sm text-slate-500 mb-6 max-w-md">
      The page you&apos;re looking for doesn&apos;t exist or you don&apos;t have access to it.
    </p>
    <Link
      to="/"
      data-testid="dashboard-not-found-back-link"
      className="text-sm text-blue-600 hover:text-blue-700 underline"
    >
      Return to your workspace
    </Link>
  </div>
);

export default DashboardNotFound;
